import Routes from './routes'
import ReducerFuncs from './store'

const Reducers = (reducerObj) => { reducerObj.features = ReducerFuncs }

export {
  Routes,
  Reducers
}
